import React from 'react';
import Typo from '../typo';

const MatchPlayerStatus = ({ matchId }) => {
  return (
    <div className='si-MatchPlayer__status'>
      <Typo transKey={"already_used"} component={'p'} className='si-MatchPlayer__status-info'>
      </Typo>
      <Typo component={'em'} className='si-MatchPlayer__status-info-em'>
        {`Match ${matchId}`}
      </Typo>
    </div>
  );
};

export default MatchPlayerStatus;
